import { Role } from './role';

export class LoggedInUser {
  email: string;
  userId: string;
  name: string;
  role: Role;
    redirectUrl: any;
}
